export const PRODUCTION_PORTAL_HOST = 'portal.flipdish.com';

export const TRUSTED_PORTAL_REDIRECT_HOSTS = [
  'portal.flipdish.com',
  'portal.flipdishdev.com',
  'flipdish.dev',
] as const;

/**
 * True when the hostname is exactly the trusted host, or a dotted subdomain of it.
 * Prefer this over substring checks (e.g. `.includes`) so hosts like
 * `portal.flipdish.com.evil.com` are not treated as trusted.
 */
export const isHostnameOnTrustedHost = (hostname: string, trustedHost: string): boolean =>
  hostname === trustedHost || hostname.endsWith(`.${trustedHost}`);

/**
 * True when the hostname is exactly the production portal host, or a subdomain of it.
 * Prefer this over substring checks (e.g. `.includes`) so hosts like
 * `portal.flipdish.com.evil.com` are not treated as production.
 */
export const isProductionPortalHost = (
  hostname: string = window.location?.hostname ?? ''
): boolean => isHostnameOnTrustedHost(hostname, PRODUCTION_PORTAL_HOST);

const LOCAL_PORTAL_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]']);

/**
 * True when the hostname is a local development host (localhost / loopback).
 */
export const isLocalPortalHost = (hostname: string = window.location?.hostname ?? ''): boolean =>
  LOCAL_PORTAL_HOSTS.has(hostname);

export const isTrustedPortalRedirectUrl = (url: string): boolean => {
  if (!url) {
    return false;
  }

  try {
    const parsedUrl = new URL(url);
    if (parsedUrl.protocol !== 'https:') {
      return false;
    }
    if (parsedUrl.username || parsedUrl.password) {
      return false;
    }
    return TRUSTED_PORTAL_REDIRECT_HOSTS.some((trustedHost) =>
      isHostnameOnTrustedHost(parsedUrl.hostname, trustedHost)
    );
  } catch {
    return false;
  }
};
